export default "__VITE_ASSET__1d17d7f7__"